import React from "react";
import { DatePicker } from "antd";
import moment from "moment";

/**
 * Month or year picker for dashboard chart toolbars.
 * Uses Ant Design to match event Select styling and avoid react-date-picker layout bugs.
 */
const DashboardDatePicker = ({ mode = "month", value, onChange, className = "" }) => {
  const isMonth = mode === "month";

  return (
    <DatePicker
      picker={isMonth ? "month" : "year"}
      className={`dashboard-date-picker ${className}`.trim()}
      value={value ? moment(value) : null}
      onChange={(date) => onChange(date ? date.toDate() : null)}
      format={isMonth ? "MMM YYYY" : "YYYY"}
      allowClear={false}
      inputReadOnly
      getPopupContainer={() => document.body}
    />
  );
};

export default DashboardDatePicker;
